const STORAGE_KEY = 'quecai-chunk-recovery'
const RETRY_WINDOW_MS = 60_000
let recovering = false

export function isChunkLoadError(error) {
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (?:CSS )?chunk .+ failed/i.test(error?.message || '')
}

// 同一地址一分钟内只恢复一次；后续发布或临时网络恢复后仍可重试，不永久锁死标签页。
export function recoverFromChunkLoadError(error, target = window.location.href) {
  if (!isChunkLoadError(error) || !navigator.onLine || recovering) return false
  const url = new URL(target, window.location.href)
  if (url.origin !== window.location.origin) return false
  const key = url.pathname + url.search + url.hash
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
    const now = Date.now()
    // 迁移旧版永久路径数组；旧标记不应再阻止以后发布时的恢复。
    const attempted = stored && typeof stored === 'object' && !Array.isArray(stored)
      ? Object.fromEntries(Object.entries(stored).filter(([, time]) =>
        Number.isFinite(time) && now - time >= 0 && now - time < RETRY_WINDOW_MS))
      : {}
    if (Object.prototype.hasOwnProperty.call(attempted, key)) return false
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...attempted, [key]: now }))
  } catch {
    // 无法保存重试标记时不自动刷新，否则无法保证不会循环。
    return false
  }
  recovering = true
  if (url.href === window.location.href) window.location.reload()
  else window.location.replace(url.href)
  return true
}

export function installChunkRecovery(router) {
  let pendingTarget = null
  router.beforeEach((to) => {
    pendingTarget = router.resolve(to).href
  })
  router.afterEach(() => { pendingTarget = null })
  router.onError((error, to) => {
    recoverFromChunkLoadError(error, router.resolve(to).href)
    pendingTarget = null
  })
  window.addEventListener('vite:preloadError', (event) => {
    recoverFromChunkLoadError(event.payload, pendingTarget || window.location.href)
  })
  // 浏览器后退可能从 bfcache 恢复旧的 JS 执行状态，恢复本页的重试能力。
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) recovering = false
  })
}
